import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Search from '@/views/Search.vue'
import Login from '@/views/Login.vue'
const Boms = () => import(/* webpackChunkName: "group-boms" */ '@/views/Boms.vue')
const BomsCreate = () => import(/* webpackChunkName: "group-boms" */ '@/views/Boms/Create.vue')
const Articles = () => import(/* webpackChunkName: "group-articles" */ '@/views/Articles.vue')
const ArticlesList = () => import(/* webpackChunkName: "group-articles" */ '@/views/Articles/List.vue')
const ArticlesDetail = () => import(/* webpackChunkName: "group-articles" */ '@/views/Articles/Detail.vue')
const Orders = () => import(/* webpackChunkName: "group-orders" */ '@/views/Orders.vue')
const OrdersList = () => import(/* webpackChunkName: "group-orders" */ '@/views/Orders/List.vue')
const Suppliers = () => import(/* webpackChunkName: "group-suppliers" */ '@/views/Suppliers.vue')
const SuppliersList = () => import(/* webpackChunkName: "group-suppliers" */ '@/views/Suppliers/List.vue')
const SuppliersConsole = () => import(/* webpackChunkName: "group-suppliers" */ '@/views/Suppliers/Console.vue')
const Api = () => import(/* webpackChunkName: "group-api" */ '@/views/Api.vue')
const Users = () => import(/* webpackChunkName: "group-admin" */ '@/views/Users.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: { requiresAuth: true }
  },
  {
    path: '/articles',
    component: Articles,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Articles',
        component: ArticlesList,
        meta: { requiresAuth: true }
      },
      {
        path: ':id',
        name: 'ArticlesDetail',
        component: ArticlesDetail,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/boms',
    component: Boms,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'BomsCreate',
        component: BomsCreate,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/orders',
    component: Orders,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'OrdersList',
        component: OrdersList,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/suppliers',
    component: Suppliers,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Suppliers',
        component: SuppliersList,
        meta: { requiresAuth: true }
      },
      {
        path: ':id/console',
        name: 'SuppliersConsole',
        component: SuppliersConsole,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/api',
    name: 'Api',
    component: Api
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '*',
    redirect: 'Search'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const user = store.state.user
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const isAdmin = store.getters.isAdmin
  if (requiresAuth && !user) {
    next({ name: 'Login' })
  } else if (requiresAdmin && !isAdmin) {
    next({ name: 'Search' })
  } else {
    next()
  }
})

export default router
